import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=1182b6aa&scoped=true&"
import script from "./Queue.vue?vue&type=script&lang=js&"
export * from "./Queue.vue?vue&type=script&lang=js&"
import style0 from "./Queue.vue?vue&type=style&index=0&id=1182b6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182b6aa",
  null
  
)

export default component.exports